import { useEffect, useState, useCallback } from "react";
import { api, formatApiError } from "@/lib/api";
import { money, fmtDate, PAYMENT_LABELS } from "@/lib/format";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Badge } from "@/components/ui/badge";
import { Search, Printer } from "lucide-react";
import { toast } from "sonner";

export default function SalesHistory() {
  const [q, setQ] = useState("");
  const [sales, setSales] = useState([]);

  const load = useCallback(() => api.get("/sales", { params: { q: q || undefined } }).then((r) => setSales(r.data)).catch(() => {}), [q]);
  useEffect(() => { const t = setTimeout(load, 250); return () => clearTimeout(t); }, [load]);

  const reprint = (id) => api.post(`/sales/${id}/reprint`).then(() => toast.success("Reprint sent")).catch((e) => toast.error(formatApiError(e)));

  return (
    <div className="max-w-6xl space-y-4">
      <div className="relative max-w-md">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
        <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search receipt, customer, cashier, item…" className="pl-9" data-testid="sales-search-input" />
      </div>
      <Card className="divide-y">
        {sales.map((s) => (
          <div key={s.id} className="flex items-center gap-3 p-3 text-sm" data-testid={`history-row-${s.id}`}>
            <div className="flex-1"><span className="font-medium">#{s.receipt_no}</span> · {s.cashier_name}{s.customer_name ? ` · ${s.customer_name}` : ""}<div className="text-xs text-slate-400">{fmtDate(s.created_at)} · {s.items.length} items</div></div>
            {s.is_prize ? <Badge className="bg-amber-100 text-amber-700">PRIZE</Badge> : <span className="text-xs text-slate-500">{PAYMENT_LABELS[s.payment_type]}</span>}
            {s.is_refunded && <Badge variant="secondary">Refunded</Badge>}
            <span className="font-semibold w-20 text-right">{money(s.total)}</span>
            <Button variant="ghost" size="icon" onClick={() => reprint(s.id)} data-testid={`history-reprint-${s.id}`}><Printer className="w-4 h-4" /></Button>
          </div>
        ))}
        {sales.length === 0 && <div className="p-8 text-center text-slate-400 text-sm">No sales found.</div>}
      </Card>
    </div>
  );
}
